<template>
  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left teacher-course-dept-pane">
      <div class="dept-scope-bar">
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': treeDirectoryScope === 'teaching' }"
          @click="setTreeDirectoryScope('teaching')"
        >家校通讯录</button>
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': treeDirectoryScope === 'internal' }"
          @click="setTreeDirectoryScope('internal')"
        >内部通讯录</button>
      </div>
      <DepartmentPane
        :key="treeDirectoryScope"
        :directory-scope="treeDirectoryScope"
        :pane-title="treePaneTitle"
        @tree-node-click="treeNodeClick"
      />
    </section>

    <section class="dp-right">
      <el-alert
        v-if="isInternalLegacyTree"
        class="legacy-tree-tip"
        type="warning"
        :closable="false"
        show-icon
        title="当前为内部通讯录"
        description="按行政部门查看教师岗位（含内部同步产生的登录用任教）。正式班级任课 / 班主任请切换到「家校通讯录」。"
      />
      <!--工具条-->
      <div class="teacher-course-toolbar-row">
        <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
        <el-button
          type="warning"
          size="small"
          plain
          icon="el-icon-link"
          :loading="loginBindingScanLoading"
          @click="openLoginBindingRepairDialog"
        >钉钉登录绑定修复</el-button>
      </div>
      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="handleRowClick" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Id" label="任教ID" width="160"> </el-table-column>
        <el-table-column prop="TeacherName" label="姓名" min-width="88">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.HasMasterError ? 'red' : 'inherit' }">
              {{ scope.row.TeacherName }}
              <i v-if="scope.row.HasMasterError" class="el-icon-warning" title="主教信息丢失"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="CardNumber" label="卡号" min-width="110">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.HasMasterError ? 'red' : 'inherit' }">
              {{ scope.row.CardNumber }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="TeacherTypeStr" label="职务类型" min-width="96">
        </el-table-column>
        <el-table-column prop="TeachCourseNames" label="教学科目" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="IsClassTeacher" label="班主任" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="
              scope.row.TeacherType == 'teacher' &&
              scope.row.IsClassTeacher == 1
            " type="success" disable-transitions>是
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" class="edit-btn" round
              @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--新增/编辑界面-->
      <el-dialog :title="isEdit ? '编辑任教信息' : '新增任教信息'" :visible.sync="addFormVisible" v-model="addFormVisible"
        :close-on-click-modal="false" destroy-on-close>
        <el-form :model="addForm" label-width="90px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item v-if="!isEdit" label="教师部门">
            <el-cascader v-model="teacherScopeDepartmentId" :options="internalDepartmentOptions"
              :props="internalDepartmentProps" clearable filterable style="width: 100%"
              placeholder="请先选择教师所在部门" @change="handleTeacherScopeDepartmentChange" />
          </el-form-item>
          <el-form-item label="教师人员" prop="Id">
            <el-select v-model="addForm.Id" placeholder="请选择" filterable
              :disabled="isEdit || !teacherScopeDepartmentId">
              <el-option
                v-for="item in teacherMasterList"
                :key="normalizeDeptId(item.Id)"
                :label="item.TeacherName"
                :value="normalizeDeptId(item.Id)"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="任教部门" prop="DepartmentId" v-if="isClassDept">
            <el-select v-model="addForm.DepartmentId" placeholder="请选择" filterable multiple style="width: 100%">
              <el-option
                v-for="item in departmentList"
                :key="normalizeDeptId(item.Id)"
                :label="item.Name"
                :value="normalizeDeptId(item.Id)"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否班主任" prop="IsClassTeacher" width v-if="isClassDept">
            <el-switch v-model="addForm.IsClassTeacher"></el-switch>
          </el-form-item>

          <el-form-item label="科目" prop="CourseIds">
            <el-select v-model="addForm.CourseIds" filterable multiple placeholder="请选择科目" style="width: 100%">
              <el-option
                v-for="item in courseList"
                :key="normalizeDeptId(item.Id)"
                :label="item.CourseName"
                :value="normalizeDeptId(item.Id)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 导入任教信息：选择文件 -->
      <el-dialog :visible.sync="courseImportDialogVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onCourseImportDialogClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-notebook-2"></i></span>
          <div>
            <strong>批量导入任教信息</strong>
            <p>可直接使用「导出」文件修改后导回；列与模板一致</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>按列填写任教信息</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="downloadCourseImportTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>任教信息批量导入模板.xlsx</strong>
              <em>含教师姓名、部门名称、是否班主任、关联校区、科目名称（多科用逗号分隔）</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
          </button>
          <el-upload :key="'course-upload-' + courseImportUploadKey" ref="courseImportUpload"
            class="pi-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
            accept=".xlsx,.xls" :on-change="onCourseImportFileChange" :on-remove="onCourseImportFileRemove"
            :on-exceed="onCourseImportExceed">
            <div v-if="courseImportFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ courseImportFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」进入核对</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="courseImportDialogVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!courseImportFileRaw"
            :loading="courseImportParsing" @click="parseCourseImportFile">
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 任教信息导入核对 -->
      <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { this.backToCourseImportSelect(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>任教信息导入核对</strong>
            <p>共 {{ outputs.length }} 条，确认无误后写入系统</p>
          </div>
        </div>
        <el-table :data="outputs" ref="outputs_table" class="pi-preview-table" border stripe
          style="width: 100%" max-height="520">
          <el-table-column prop="TeacherName" label="教师姓名" width="100" show-overflow-tooltip />
          <el-table-column prop="DepartmentName" label="部门名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="IsClassTeacher" label="是否班主任" width="100">
            <template slot-scope="scope">
              {{ scope.row.IsClassTeacher ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="CampusName" label="关联校区" min-width="110" show-overflow-tooltip />
          <el-table-column prop="CourseNames" label="科目名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ (scope.row.CourseNames || []).join(", ") }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pi-import-clear-bar" :class="{ 'is-on': courseImportClearAll }">
          <div class="pi-import-clear-bar__text">
            <strong>清除本校全部班级任教后再导入</strong>
            <em>开启后先删除本校班级任教，再按本表重建；关闭则保留现有，仅新增/更新。不影响年级/校区职务及内部登录用任教。</em>
          </div>
          <el-switch
            v-model="courseImportClearAll"
            active-text="清除"
            inactive-text="保留"
          />
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToCourseImportSelect">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">
            {{ courseImportClearAll ? '清除并导入' : '确认导入' }}
          </el-button>
        </div>
      </el-dialog>

      <import-result-dialog
        :visible.sync="importResultVisible"
        :result="importResult"
      />

      <!-- 钉钉登录绑定修复 -->
      <el-dialog 
        title="钉钉登录绑定修复"
        :visible.sync="loginBindingDialogVisible"
        width="860px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-alert
          type="info"
          :closable="false"
          show-icon
          title="适用场景"
          description="教师主档已有钉钉 ID，但缺登录绑定（含：有任教无 MpUser/Assign，或仅有主教无任教——一键补全时会先补登录用伪任教再写映射）。"
          style="margin-bottom: 12px;"
        />
        <div v-if="loginBindingScanResult" class="login-binding-toolbar">
          <div class="login-binding-summary">
            <span>学校：{{ loginBindingScanResult.SchoolName || '-' }}</span>
            <span>AppId：{{ loginBindingScanResult.AppId || '-' }}</span>
            <span>缺绑定：{{ loginBindingTotalCount }} 人</span>
          </div>
          <el-input
            v-model="loginBindingKeyword"
            clearable
            size="small"
            prefix-icon="el-icon-search"
            placeholder="搜索姓名 / 钉钉ID"
            class="login-binding-search"
            @keyup.enter.native="onLoginBindingSearch"
            @clear="onLoginBindingSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="onLoginBindingSearch" />
          </el-input>
        </div>
        <el-table
          v-loading="loginBindingScanLoading"
          :data="loginBindingPageItems"
          border
          stripe
          max-height="420"
          :empty-text="loginBindingKeyword.trim() ? '未找到匹配教师' : '暂无缺绑定教师'"
        >
          <el-table-column prop="TeacherName" label="姓名" width="100" />
          <el-table-column prop="ThirdPartyCode" label="钉钉ID" min-width="160" show-overflow-tooltip />
          <el-table-column prop="TeacherInfoCount" label="任教数" width="80" align="center" />
          <el-table-column prop="MpUserCount" label="MpUser" width="80" align="center" />
          <el-table-column prop="AssignCount" label="Assign" width="80" align="center" />
          <el-table-column prop="MissingReason" label="缺失原因" min-width="140" show-overflow-tooltip />
          <el-table-column label="操作" width="90" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                :loading="String(loginBindingRepairingMasterId) === String(scope.row.TeacherMasterId)"
                @click="repairSingleLoginBinding(scope.row)"
              >修复</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="login-binding-pager">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :current-page.sync="loginBindingPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="loginBindingPageSize"
            :total="loginBindingTotalCount"
            @size-change="onLoginBindingPageSizeChange"
            @current-change="scanMissingLoginBindings"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="loginBindingDialogVisible = false">关闭</el-button>
          <el-button :loading="loginBindingScanLoading" @click="scanMissingLoginBindings">重新扫描</el-button>
          <el-button
            type="primary"
            :loading="loginBindingRepairLoading"
            :disabled="loginBindingTotalCount <= 0 && loginBindingPageItems.length === 0"
            @click="repairMissingLoginBindings"
          >一键补全</el-button>
        </span>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getTeacherInfo, delClassTeacher, getTeacherMasterList, addClassTeacher, importClassTeacherBatch, exportTeacherInfo, getMissingLoginBindings, repairLoginBindings } from '../../api/modules/personnel';
import { getInternalDepartmentTree, getStudentLiveTypeList, getSubDepartmentList } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { GetSysCourseByDepartmentId } from '../../api/modules/schedule-course';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import ImportResultDialog from "../../components/ImportResultDialog";
import { getDeptCascaderProps, resolveActiveSchoolId, scopedDeptTreeToCascaderOptions } from "../../utils/deptCascaderProps";
// excel 读取
import { read, utils, writeFile } from "xlsx";
import "../../style/person-import-dialog.css";
export default {
  components: { Toolbar, DepartmentPane, ImportResultDialog },
  data() {
    return {
      filters: {},
      searchList: [
        {
          label: "姓名",
          key: "teacherName",
        },
        {
          label: "数据状态",
          key: "hasMasterError",
          type: "select",
          options: [
            { label: "全部", value: "" },
            { label: "正常", value: false },
            { label: "异常(未关联)", value: true },
          ],
        },
      ],
      BaseApiUrl: BaseApiUrl, //网络前缀
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      isEdit: false, // 是否是编辑模式
      addLoading: false,
      addFormRules: {
        Id: [{ required: true, message: "请选择教师", trigger: "change" }],
      },
      //新增界面数据
      addForm: {
        DepartmentId: [],
        Id: "",
        IsClassTeacher: false,
        CourseIds: [],
      },
      DepartmentId: 0,
      currentDeptName: "",
      /** 左侧组织树范围：teaching 家校正式任教 / internal 内部行政部门岗位 */
      treeDirectoryScope: "teaching",

      imageUrl: "",
      imageLoadding: false,
      teacherMasterList: [],
      teacherScopeDepartmentId: null,
      internalDepartmentOptions: [],
      internalDepartmentProps: getDeptCascaderProps({
        checkStrictly: true,
        emitPath: false,
      }),
      departmentList: [],
      isClassDept: true,
      currentClassType: "",
      multipleSelection: [],
      courseList: [],

      //excel
      outputs: [],
      excelShow: false,
      courseImportDialogVisible: false,
      courseImportFileRaw: null,
      courseImportParsing: false,
      courseImportUploadKey: 0,
      courseImportKeepFileOnClose: false,
      /** 导入前是否清除本校全部班级任教。最后更新：2026-09-20 */
      courseImportClearAll: false,
      exportLoading: false, // 导出加载状态
      // 导入结果弹窗
      importResultVisible: false,
      importResult: null,
      loginBindingDialogVisible: false,
      loginBindingScanLoading: false,
      loginBindingRepairLoading: false,
      loginBindingRepairingMasterId: null,
      loginBindingScanResult: null,
      loginBindingKeyword: "",
      loginBindingPage: 1,
      loginBindingPageSize: 20,
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleRowClick(row) {
      if (!this.$refs.table) return;
      this.$refs.table.toggleRowSelection(row);
    },
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true;
      return true;
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false;
      console.log(res);
      this.imageUrl = res.response;
    },

    handleChange(value) {
      this.liveTypeList = [];
      this.liveTypeId = "";
      var id = "";
      if (value.length > 1) {
        id = value[value.length - 1];
      } else {
        id = value[0];
      }
      let para = {
        id: id,
      };
      getStudentLiveTypeList(para).then((res) => {
        this.liveTypeList = res.data.response;
      });
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value;
      this.currentDeptName = data.label || data.Name || "";
      this.currentClassType = data.DeptOrgType || "";
      // 内部树按左侧行政部门选岗；家校树仍按班级/年级展示任教部门。最后更新：2026-09-04
      this.isClassDept = this.treeDirectoryScope === "teaching"
        && (data.DeptOrgType === "class" || data.DeptOrgType === "grade");
      this.handleQuery();
    },
    /**
     * 当前顶部固定学校 ID。最后更新：2026-08-29
     */
    resolveSchoolId() {
      return resolveActiveSchoolId(this);
    },
    /**
     * 加载当前学校内部通讯录部门，供新增任教时按教师所在部门筛选。
     */
    loadInternalTeacherDepartments(schoolId) {
      if (!schoolId) {
        this.internalDepartmentOptions = [];
        return;
      }
      getInternalDepartmentTree({ scopeDepartmentId: schoolId }).then((res) => {
        const root = res && res.data ? res.data.response : null;
        this.internalDepartmentOptions = scopedDeptTreeToCascaderOptions(root, {
          clearAllDisabled: true,
          keepSchoolRoot: true,
          internalOnly: true,
        });
      }).catch(() => {
        this.internalDepartmentOptions = [];
      });
    },
    /**
     * 根据内部部门加载可选教师；切换部门时清空原教师。
     */
    handleTeacherScopeDepartmentChange(departmentId) {
      this.addForm.Id = "";
      this.teacherMasterList = [];
      if (!departmentId) return;
      getTeacherMasterList({
        departmentId,
        schoolDirectOnly: true,
      }).then((res) => {
        this.teacherMasterList = (res.data && res.data.response) || [];
      });
    },
    /**
     * 雪花 ID 统一转字符串，避免 Number 精度丢失与 el-select 类型对不上。最后更新：2026-08-30
     */
    normalizeDeptId(value) {
      if (value === undefined || value === null || value === '') return '';
      return String(value).trim();
    },
    /**
     * 加载新增/编辑弹窗下拉：教师按学校、任教部门按当前班级/年级。最后更新：2026-08-30
     * @param {{ departmentId?: number|string, departmentName?: string, orgType?: string }} [context]
     */
    loadTeachingFormOptions(context) {
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        this.$message.warning("请先在顶部选择学校");
        this.teacherMasterList = [];
        this.departmentList = [];
        this.courseList = [];
        return;
      }

      this.loadInternalTeacherDepartments(schoolId);
      if (this.isEdit) {
        // 编辑时教师不可变，仅为已有值补充显示名称。
        getTeacherMasterList({ departmentId: schoolId }).then((res) => {
          this.teacherMasterList = (res.data && res.data.response) || [];
        });
      } else {
        this.teacherMasterList = [];
      }

      const ctxDeptId = this.normalizeDeptId(
        (context && context.departmentId) || this.DepartmentId
      );
      const ctxDeptName = (context && context.departmentName)
        || this.currentDeptName
        || "";
      const orgType = (context && context.orgType) || this.currentClassType || "";

      if (orgType === "class" || (!orgType && ctxDeptId && this.isClassDept && this.currentClassType === "class")) {
        // 班级无子部门，不能用 getSubDepartmentList(班级Id)
        this.departmentList = [{ Id: ctxDeptId, Name: ctxDeptName || "当前班级" }];
        if (!this.isEdit) {
          this.addForm.DepartmentId = [ctxDeptId];
        } else if (!this.addForm.DepartmentId || !this.addForm.DepartmentId.length) {
          this.addForm.DepartmentId = [ctxDeptId];
        } else {
          this.addForm.DepartmentId = (this.addForm.DepartmentId || [])
            .map((id) => this.normalizeDeptId(id))
            .filter(Boolean);
        }
      } else if (orgType === "grade" || this.currentClassType === "grade") {
        getSubDepartmentList({ pid: ctxDeptId || this.DepartmentId }).then((res) => {
          const list = (res.data && res.data.response) || [];
          this.departmentList = list.map((d) => ({
            ...d,
            Id: this.normalizeDeptId(d.Id),
          }));
        });
      } else if (ctxDeptId) {
        // 编辑回显：至少保证当前任教班级可选
        this.departmentList = [{
          Id: ctxDeptId,
          Name: ctxDeptName || ctxDeptId,
        }];
        getSubDepartmentList({ pid: ctxDeptId }).then((res) => {
          const children = (res.data && res.data.response) || [];
          if (children.length) {
            const map = {};
            this.departmentList.concat(children).forEach((d) => {
              const id = this.normalizeDeptId(d.Id);
              map[id] = { ...d, Id: id };
            });
            this.departmentList = Object.keys(map).map((k) => map[k]);
          }
        });
      } else {
        this.departmentList = [];
      }

      // 科目：用当前树节点或学校
      const courseDeptId = ctxDeptId || schoolId;
      GetSysCourseByDepartmentId({ departmentId: courseDeptId }).then((res) => {
        const list = (res.data && res.data.response) || [];
        this.courseList = list.map((c) => ({
          ...c,
          Id: this.normalizeDeptId(c.Id),
        }));
      });
    },
    callFunction(item) {
      if (typeof item.search == "object") {
        this.filters = item.search;
      } else {
        this.filters = {
          key: item.search,
        };
      }
      this[item.Func].apply(this, item);
    },

    //性别显示转换
    formatSex: function (row, column) {
      return row.Sex == 1 ? "男" : row.Sex == 0 ? "女" : "未知";
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    // 导出任教教师
    async exportExcel() {
      try {
        const para = {
          departmentId: this.DepartmentId,
          directoryScope: this.treeDirectoryScope,
          ...this.filters,
        };
        const response = await exportTeacherInfo(para);
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `任教信息导出_${new Date().getTime()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$message({ message: "导出成功", type: "success" });
      } catch (error) {
        console.error("导出失败:", error);
        this.$message({ message: "导出失败", type: "error" });
      }
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        directoryScope: this.treeDirectoryScope,
        ...this.filters,
      };
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getTeacherInfo(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      // 获取选中的多行数据
      const selectedRows = this.multipleSelection;

      // 检查是否有选中的行
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning("请先选择要删除的数据");
        return;
      }

      this.$confirm(
        `确认删除选中的 ${selectedRows.length} 条数据吗？`,
        "提示",
        {
          type: "warning",
        },
      )
        .then(() => {
          this.listLoading = true;
          const ids = selectedRows.map((row) => row.Id).join(",");
          let para = { ids: ids };
          delClassTeacher(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleEdit(index, row) {
      this.isEdit = true;
      this.addFormVisible = true;
      this.teacherScopeDepartmentId = null;
      // 编辑时强制显示任教部门和是否班主任字段
      this.isClassDept = true;
      const deptId = this.normalizeDeptId(row.DepartmentId);
      this.addForm = {
        DepartmentId: deptId ? [deptId] : [],
        Id: this.normalizeDeptId(row.TeacherMasterUid), // 绑定教师ID（用于回显下拉框）
        TeacherInfoId: row.Id, // 保存任教记录ID（用于编辑保存）
        IsClassTeacher:
          row.IsClassTeacher === 1 ||
          row.IsClassTeacher === "1" ||
          row.IsClassTeacher === true,
        // 后端返回的是逗号分隔的字符串，需要转换为数组以适配 el-select multiple
        CourseIds: row.TeachCourseIds
          ? String(row.TeachCourseIds).split(",").map((id) => this.normalizeDeptId(id)).filter(Boolean)
          : [],
      };

      this.loadTeachingFormOptions({
        departmentId: deptId,
        departmentName: row.DepartmentName,
        orgType: "class",
      });
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.teacherScopeDepartmentId = null;
      this.addForm = {
        DepartmentId: [],
        Id: "",
        IsClassTeacher: false,
        CourseIds: [],
      };
      this.addFormVisible = true;
      this.loadTeachingFormOptions();
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;

            let para = Object.assign({}, this.addForm);

            if (!this.isClassDept) {
              para.DepartmentId = [this.DepartmentId];
            }

            addClassTeacher(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.teacherMasterList = [];
                this.departmentList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },

    // 导入：打开选择弹窗
    ImportCensus() {
      this.resetCourseImportDialog();
      this.courseImportClearAll = false;
      this.courseImportDialogVisible = true;
    },
    resetCourseImportDialog() {
      this.courseImportFileRaw = null;
      this.courseImportParsing = false;
      this.courseImportUploadKey += 1;
    },
    onCourseImportDialogClosed() {
      if (this.courseImportKeepFileOnClose) {
        this.courseImportKeepFileOnClose = false;
        return;
      }
      this.resetCourseImportDialog();
    },
    backToCourseImportSelect() {
      this.excelShow = false;
      this.courseImportDialogVisible = true;
    },
    onCourseImportFileChange(file) {
      this.courseImportFileRaw = file && file.raw ? file.raw : null;
    },
    onCourseImportFileRemove() {
      this.courseImportFileRaw = null;
    },
    onCourseImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.courseImportUploadKey += 1;
      this.$nextTick(() => {
        this.courseImportFileRaw = nextFile;
      });
    },
    // 下载任教信息导入模板。最后更新：2026-09-12
    downloadCourseImportTemplate() {
      const headers = [
        "教师姓名", "部门名称", "是否班主任", "关联校区", "科目名称"
      ];
      const sample = [
        "张老师", "一年级1班", "是", "主校区", "语文,数学"
      ];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, "任教导入");
      writeFile(book, "任教信息批量导入模板.xlsx");
    },
    parseCourseImportFile() {
      if (!this.courseImportFileRaw) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const file = this.courseImportFileRaw;
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return;
      }
      this.courseImportParsing = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = read(data, { type: "binary" });
          const wsname = workbook.SheetNames[0];
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          this.outputs = this.reSetKey(ws);
          this.courseImportParsing = false;
          this.courseImportKeepFileOnClose = true;
          this.courseImportDialogVisible = false;
          this.excelShow = true;
        } catch (e) {
          this.courseImportParsing = false;
          this.$message.error("文件读取失败");
        }
      };
      fileReader.onerror = () => {
        this.courseImportParsing = false;
        this.$message.error("文件读取失败");
      };
      fileReader.readAsBinaryString(file);
    },
    // 删除错误行
    removeImport(e) {
      this.$confirm("确定要删除" + e.row.TeacherName + "的信息").then(() => {
        this.outputs.splice(e["$index"], 1);
      });
    },
    /**
     * 确认导入任教：按核对页开关决定是否先清除班级任教。最后更新：2026-09-20
     */
    SavaImport() {
      const schoolDepartmentId = this.resolveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning("请先在顶部选择学校");
        return;
      }
      if (!this.outputs || !this.outputs.length) {
        this.$message.warning("没有可导入的数据");
        return;
      }

      const clearAll = !!this.courseImportClearAll;
      const runImport = () => {
        const loading = this.$loading({
          lock: true,
          text: clearAll ? "清除班级任教并导入中" : "导入中",
          background: "rgba(0, 0, 0, 0.7)",
        });

        importClassTeacherBatch({
          schoolDepartmentId: schoolDepartmentId,
          clearAllClassTeaching: clearAll,
          items: this.outputs,
        })
          .then((res) => {
            loading.close();
            const msg = (res.data && res.data.msg) || "";
            if (res.data && res.data.success) {
              this.importResult = res.data.response || null;
              this.importResultVisible = true;
              this.excelShow = false;
              this.courseImportClearAll = false;
              this.handleQuery();
            } else {
              this.importResult = res.data && res.data.response ? res.data.response : null;
              this.importResultVisible = true;
              if (!this.importResult) {
                this.$message.error(msg || "导入失败");
              }
            }
          })
          .catch(() => {
            loading.close();
            this.$message({
              message: "导入失败",
              type: "error",
            });
          });
      };

      if (!clearAll) {
        runImport();
        return;
      }

      this.$confirm(
        "将清除本校全部班级任教后再按本表创建，是否继续？",
        "确认清除并导入",
        { type: "warning", confirmButtonText: "确定清除并导入", cancelButtonText: "取消" }
      ).then(runImport).catch(() => {});
    },
    reSetKey(ws) {
      let temp = [];
      ws.forEach((item) => {
        // 兼容导入模板列名，以及历史导出版本的别名。最后更新：2026-09-12
        const courseRaw = item["科目名称"] || item["教学科目"] || "";
        const isClassTeacherRaw =
          item["是否班主任"] != null ? item["是否班主任"] : (item["班主任"] || "");
        temp.push({
          TeacherName: item["教师姓名"] || item["姓名"] || "",
          DepartmentName: item["部门名称"] || item["部门"] || item["所属部门"] || "",
          CampusName: item["关联校区"] || "",
          IsClassTeacher:
            isClassTeacherRaw === "是" ||
            isClassTeacherRaw === "true" ||
            isClassTeacherRaw === true ||
            false,
          CourseNames: courseRaw
            ? String(courseRaw).split(/[,，]/).map((s) => s.trim()).filter(Boolean)
            : [],
        });
      });
      return temp;
    },
    /**
     * 切换左侧组织树：家校为正式班级任教，内部为行政部门岗位。最后更新：2026-09-04
     */
    setTreeDirectoryScope(scope) {
      if (this.treeDirectoryScope === scope) return;
      this.treeDirectoryScope = scope;
      this.DepartmentId = 0;
      this.currentDeptName = "";
      this.currentClassType = "";
      this.isClassDept = scope === "teaching";
      this.page = 1;
      this.users = [];
      this.total = 0;
    },
    async openLoginBindingRepairDialog() {
      const schoolDepartmentId = this.resolveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning("请先在顶部选择学校");
        return;
      }
      this.loginBindingDialogVisible = true;
      this.loginBindingKeyword = "";
      this.loginBindingPage = 1;
      await this.scanMissingLoginBindings();
    },
    onLoginBindingSearch() {
      this.loginBindingPage = 1;
      this.scanMissingLoginBindings();
    },
    onLoginBindingPageSizeChange() {
      this.loginBindingPage = 1;
      this.scanMissingLoginBindings();
    },
    async scanMissingLoginBindings() {
      const schoolDepartmentId = this.resolveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning("请先在顶部选择学校");
        return;
      }
      this.loginBindingScanLoading = true;
      try {
        const res = await getMissingLoginBindings({
          schoolDepartmentId,
          page: this.loginBindingPage,
          intPageSize: this.loginBindingPageSize,
          keyWord: (this.loginBindingKeyword || "").trim(),
        });
        if (res.data && res.data.success) {
          this.loginBindingScanResult = res.data.response || { Items: [], TotalCount: 0 };
          // TotalCount 缺失或为 0 但当前页有数据时，用条数兜底，避免一键补全误灰。最后更新：2026-09-04
          const payload = this.loginBindingScanResult;
          const items = payload.Items || payload.items || [];
          const rawTotal = payload.TotalCount != null ? payload.TotalCount : payload.totalCount;
          if ((rawTotal == null || Number(rawTotal) === 0) && items.length > 0) {
            payload.TotalCount = items.length;
          }
          if (this.loginBindingScanResult.Page) {
            this.loginBindingPage = this.loginBindingScanResult.Page;
          }
        } else {
          this.$message.error((res.data && res.data.msg) || "扫描失败");
        }
      } catch (e) {
        this.$message.error("扫描失败");
      } finally {
        this.loginBindingScanLoading = false;
      }
    },
    repairMissingLoginBindings() {
      const total = this.loginBindingTotalCount || this.loginBindingPageItems.length;
      if (!total) {
        this.$message.info("当前无需修复");
        return;
      }
      this.$confirm(`将为当前学校全部 ${total} 名缺绑定教师补全钉钉登录（不限当前页），是否继续？`, "确认修复", {
        type: "warning",
      }).then(() => {
        this.runLoginBindingRepair([]);
      }).catch(() => {});
    },
    repairSingleLoginBinding(row) {
      if (!row || !row.TeacherMasterId) {
        this.$message.warning("教师信息无效");
        return;
      }
      const teacherName = row.TeacherName || "该教师";
      this.$confirm(`将为「${teacherName}」补全钉钉登录绑定，是否继续？`, "确认修复", {
        type: "warning",
      }).then(() => {
        this.runLoginBindingRepair([row.TeacherMasterId]);
      }).catch(() => {});
    },
    async runLoginBindingRepair(teacherMasterIds) {
      const schoolDepartmentId = this.resolveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning("请先在顶部选择学校");
        return;
      }
      const isSingle = Array.isArray(teacherMasterIds) && teacherMasterIds.length === 1;
      if (isSingle) {
        this.loginBindingRepairingMasterId = teacherMasterIds[0];
      } else {
        this.loginBindingRepairLoading = true;
      }
      try {
        const res = await repairLoginBindings({
          schoolDepartmentId,
          teacherMasterIds: (teacherMasterIds || []).map((id) => String(id)),
        });
        if (res.data && res.data.success) {
          const result = res.data.response || {};
          this.$message.success(result.Message || res.data.msg || "修复完成");
          await this.scanMissingLoginBindings();
        } else {
          this.$message.error((res.data && res.data.msg) || "修复失败");
        }
      } catch (e) {
        this.$message.error("修复失败");
      } finally {
        this.loginBindingRepairingMasterId = null;
        this.loginBindingRepairLoading = false;
      }
    },
  },
  computed: {
    treePaneTitle() {
      return this.treeDirectoryScope === "internal" ? "内部通讯录" : "家校通讯录";
    },
    isInternalLegacyTree() {
      return this.treeDirectoryScope === "internal";
    },
    loginBindingTotalCount() {
      const result = this.loginBindingScanResult;
      if (!result) return 0;
      const total = result.TotalCount != null ? result.TotalCount : result.totalCount;
      if (total != null && Number(total) > 0) return Number(total);
      const items = result.Items || result.items || [];
      return items.length;
    },
    loginBindingPageItems() {
      const result = this.loginBindingScanResult;
      if (!result) return [];
      return result.Items || result.items || [];
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.edit-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.teacher-course-dept-pane {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.teacher-course-toolbar-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.teacher-course-toolbar-row > .toolbar {
  flex: 1;
  min-width: 0;
}

.login-binding-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.login-binding-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  color: #606266;
  font-size: 13px;
  flex: 1;
  min-width: 200px;
}

.login-binding-search {
  width: 260px;
  flex-shrink: 0;
}

.login-binding-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.teacher-course-dept-pane ::v-deep .department-pane {
  flex: 1;
  min-height: 0;
}

/* 与运维页一致：自定义树节点用 .tree-node__label，允许长名称换行。最后更新：2026-10-30 */
.teacher-course-dept-pane ::v-deep .tree-node__label {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
  text-overflow: unset;
  overflow: visible;
}

.teacher-course-dept-pane ::v-deep .el-tree-node__content {
  height: auto;
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

/* 与部门树一起折叠，收起后不再单独露出家校/内部切换条。最后更新：2026-09-02 */
.teacher-course-dept-pane.is-collapsed .dept-scope-bar {
  display: none !important;
}

/* 覆盖 scoped：原生 button 必须能收缩，否则撑破 264 侧栏。最后更新：2026-10-30 */
.dept-scope-bar {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 8px 10px 10px;
}

.dept-scope-btn {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  padding: 6px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.25;
  cursor: pointer;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color .15s ease, color .15s ease, background .15s ease;
}

.dept-scope-btn:hover {
  border-color: #93c5fd;
  color: #2563eb;
}

.dept-scope-btn.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

.legacy-tree-tip {
  margin-bottom: 10px;
  flex-shrink: 0;
}
</style>
